import {Flexbox} from '@/components/ui/flexbox/FlexBox'
import {css, styled} from 'styled-components'

export const StyledAgendaResourceHeader = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        background-color: ${palette.neutral['50']};
        height: 66px;
        padding: ${spacing * 2}px;
    `
)

export const StyledAgendaResourceHeaderContent = styled(Flexbox)(
    ({theme: {palette, spacing}}) => css`
        width: 100%;
        height: 100%;
        background-color: ${palette.neutral['white']};
        height: fit-content;
        padding: ${spacing * 1.5}px ${spacing * 2}px;
        border-radius: 6px;
        outline: 1px solid ${palette.neutral['200']};
    `
)

export const StyledAgendaResourceTitle = styled.h3(
    ({theme: {typography, palette}}) => css`
        ${typography.textXs};
        font-weight: 500;
        color: ${palette.neutral['950']};
    `
)

export const StyledAgendaResourceSubtitle = styled.p(
    ({theme: {typography, palette}}) => css`
        ${typography.textXs};
        font-weight: 400;
        color: ${palette.neutral['600']};
    `
)
